import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import NavItem from 'reactstrap/lib/NavItem';
import NavLink from 'reactstrap/lib/NavLink';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';

const APPRAISAL_LINK = {
  title: 'My Car Value',
  trackingId: 'appraisal_link_tool_select',
  url: URL_PATHS.APPRAISAL_LANDING,
  smallScreenTitle: 'Appraise',
  attributes: {
    'data-tracking-value': 'My Car Value',
  },
};

export function GlobalNavLink({
  link,
  pathname = '',
  displayFullLinksText = false,
  isMobile = true,
  enableSeot4597GlobalNavMobileUpdate = false,
  children = undefined,
  globalNavLinkClasses = 'global-nav-link text-shadow-contrast-high',
}) {
  const { titlePostfix = '', title, titlePrefix = '', smallScreenTitle = '' } = link;
  const alwaysDisplayFullLinkText =
    (enableSeot4597GlobalNavMobileUpdate && isMobile) || (displayFullLinksText && link.url === APPRAISAL_LINK.url);
  const fullLinkText = `${titlePrefix} ${title} ${titlePostfix}`.trim();

  return (
    <NavItem className="py-0_25 py-md-0" key={link.url}>
      <NavLink
        href={link.url}
        className="px-0 px-sm-0_5 px-md-1"
        data-tracking-id={link.trackingId}
        active={pathname === link.url}
        {...link.attributes}
      >
        <span className={classnames(globalNavLinkClasses)}>
          {children || (
            <>
              {alwaysDisplayFullLinkText ? (
                `${fullLinkText}`
              ) : (
                <Fragment>
                  {!!titlePrefix && <span className="d-none d-lg-inline">{`${titlePrefix} `}</span>}
                  {smallScreenTitle ? (
                    <Fragment>
                      <span className="d-lg-none">{smallScreenTitle}</span>
                      <span className="d-none d-lg-inline">{title}</span>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {title}
                      {!!titlePostfix && <span className="d-none d-lg-inline">{` ${titlePostfix}`}</span>}
                    </Fragment>
                  )}
                </Fragment>
              )}
            </>
          )}
        </span>
      </NavLink>
    </NavItem>
  );
}

GlobalNavLink.propTypes = {
  link: PropTypes.shape({
    url: PropTypes.string,
    trackingId: PropTypes.string,
    titlePostfix: PropTypes.string,
    title: PropTypes.string,
    titlePrefix: PropTypes.string,
    smallScreenTitle: PropTypes.string,
    attributes: PropTypes.shape({}),
  }).isRequired,
  pathname: PropTypes.string,
  displayFullLinksText: PropTypes.bool,
  isMobile: PropTypes.bool,
  enableSeot4597GlobalNavMobileUpdate: PropTypes.bool,
  children: PropTypes.node,
  globalNavLinkClasses: PropTypes.string,
};
